import React, { useState, useCallback } from 'react';
import BingoCardsGame from './BingoCardsGame';
import './BingoCards.css';

const BingoCards = () => {
  const [phase, setPhase] = useState('entry'); // 'entry' | 'game'
  const [selectedCardNumbers, setSelectedCardNumbers] = useState([]);
  const [cardCount, setCardCount] = useState(1);
  const [cardInputs, setCardInputs] = useState(Array(12).fill(''));
  const [entryError, setEntryError] = useState('');

  const handleCardInputChange = useCallback((index, value) => {
    const cleaned = value.replace(/\D/g, '');
    setCardInputs(prev => {
      const next = [...prev];
      next[index] = cleaned;
      return next;
    });
  }, []);

  const handleShowCards = useCallback(() => {
    setEntryError('');
    const numbers = cardInputs
      .slice(0, cardCount)
      .map(s => parseInt(s.trim(), 10))
      .filter(n => !isNaN(n) && n >= 1);

    if (numbers.length === 0) {
      setEntryError('Enter at least one card number');
      return;
    }

    setSelectedCardNumbers(numbers);
    setPhase('game');
  }, [cardInputs, cardCount]);

  const handleBack = useCallback(() => {
    setPhase('entry');
  }, []);

  return (
    <div className="bc-app">
      {phase === 'entry' && (
        <div className="bc-entry">
          <div className="bc-entry-card">
            <h1 className="bc-entry-title">Phoenix Bingo</h1>
            <p className="bc-entry-subtitle">Enter your card numbers to display them</p>

            <div className="bc-entry-count">
              <label>Number of cards</label>
              <select
                className="bc-entry-select"
                value={cardCount}
                onChange={(e) => setCardCount(Number(e.target.value))}
              >
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(n => (
                  <option key={n} value={n}>{n}</option>
                ))}
              </select>
            </div>

            <div className="bc-entry-inputs">
              <label>Enter card numbers</label>
              <div className="bc-entry-inputs-grid">
                {Array.from({ length: cardCount }, (_, i) => (
                  <input
                    key={i}
                    type="text"
                    inputMode="numeric"
                    placeholder={`Card ${i + 1}`}
                    value={cardInputs[i]}
                    onChange={(e) => handleCardInputChange(i, e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && handleShowCards()}
                    className="bc-entry-input"
                    maxLength={4}
                  />
                ))}
              </div>
            </div>

            {entryError && (
              <div className="bc-entry-error">{entryError}</div>
            )}

            <button className="bc-entry-btn primary" onClick={handleShowCards}>
              Show Cards
            </button>
          </div>
        </div>
      )}

      {phase === 'game' && (
        <BingoCardsGame
          cardNumbers={selectedCardNumbers}
          onBack={handleBack}
        />
      )}
    </div>
  );
};

export default BingoCards;
